import {Component, Input, OnInit} from "@angular/core";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'gen-aberration-column',
  templateUrl: './aberration-column.component.html',
  styleUrls: ['./aberration-column.component.scss']
})

export class AberrationColumnComponent implements OnInit {

  readonly TOOLTIP_COLUMN = 'tooltip-column';
  readonly INDICATOR_ICON_COLUMN = 'indicator-icon-column';
  readonly ICON_COLUMN = 'icon-column';
  readonly COSMIC_COLUMN = 'cosmic-column';
  readonly BOOLEAN_COLUMN = 'boolean-column';
  readonly BASIC_COLUMN = 'basic-column';

  @Input() columnValue: any;
  @Input() searchTerm: any;
  @Input() tooltipEnabled: any;

  @Input()
  set setColumnData(columnData: any) {
    this.columnData = columnData;
    if (columnData.columnType === this.INDICATOR_ICON_COLUMN) {
      this.getTooltipTextForIndicatorIconColumn();
    } else if (columnData.columnType === this.TOOLTIP_COLUMN) {
      this.getTooltipTextForTooltipColumn();
    } else if (columnData.columnType === this.ICON_COLUMN) {
      this.setValue();
      this.iconColumnTitle = this.translateService.instant('aberration.tooltip.' + this.columnData.columnName + '_' + this.value);
    }
  }

  public value: any;
  public columnData: any;
  public indicatorIconText: string;
  public tooltipColumnText: string;
  public iconColumnTitle: string;
  public displayValue: string;

  constructor(
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
  }


  /************************************ TOOLTIP_COLUMN ***********************************/

  private getTooltipTextForTooltipColumn() {
    this.setValue();
    if (this.isColumnHasSingleValue()) {
      this.tooltipColumnText = this.displayColumnValue() ? this.value : this.getTooltipTextFromTranslateFile();
    } else {
      this.tooltipColumnText = this.value + " " + this.getTooltipTextFromTranslateFile('_MultipleItems');
    }
  }

  private setValue() {
    if (this.columnData.columnType === this.TOOLTIP_COLUMN) {
      if (this.columnValue[this.columnData.columnName]) {
        this.value = this.columnValue[this.columnData.columnName].replace(/<[^>]+>/gm, '');
      }
    } else if (this.columnData.columnType === this.ICON_COLUMN ||
      this.columnData.columnType === this.COSMIC_COLUMN) {
      this.value = this.columnValue[this.columnData.columnName];
    }
  }

  private isColumnHasSingleValue(): boolean {
    const delimiter = this.columnData.tooltip ? this.columnData.tooltip.delimiter : null;
    return !delimiter || !this.value || !this.value.contains(delimiter);
  }

  private displayColumnValue() {
    return this.columnData.tooltip && this.columnData.tooltip.text === "originalValue";
  }

  private getTooltipTextFromTranslateFile(isMultipleValues?: any): string {
    const multipleText = isMultipleValues ? isMultipleValues : "";
    return this.translateService.instant('aberration.tooltip.' + this.columnData.columnName + multipleText);
  }


  /********************************** INDICATOR_ICON_COLUMN *******************************/

  private getTooltipTextForIndicatorIconColumn() {
    this.columnData.columnName === 'Actionability' ? this.displayValue = this.columnValue[this.columnData.columnName].substring(0, 1) : this.displayValue = "!";
    let translateTooltip = this.translateService.instant('aberration.tooltip.' + this.columnData.columnName);
    if (this.columnData.columnName === 'Actionability') {
      translateTooltip = this.translateService.instant('aberration.tooltip.' + this.columnValue[this.columnData.columnName]);
    }
    this.indicatorIconText = this.columnData.tooltip.text ? this.columnData.tooltip.text : translateTooltip;
  }

  public displayIcon(): boolean {
    const columnValue = this.columnValue;

    // line need to be removed after that data fix in master
    this.columnData.displayCondition = this.columnData.displayCondition ===
    "(columnValue.tumor_dp < 100 || columnValue.tumor_freq.replace('%',') < 5)" ?
      "(columnValue.tumor_dp < 100 || columnValue.tumor_freq.replace('%','') < 5)" : this.columnData.displayCondition;

    if (this.columnData.displayCondition === "(columnValue.total_reads.replace('%','') < 5)" && typeof columnValue.total_reads === 'number') {
      this.columnData.displayCondition = "(columnValue.total_reads < 5)";
    }

    return eval(this.columnData.displayCondition);
  }

  actionable(): boolean {
    return this.columnValue.Actionability === "Actionable";
  }


  /********************************** COSMIC_COLUMN *******************************/

  public cosmicURL(cosmicId: any): any {
    return this.columnData.cosmicUrl + cosmicId.replace(/^COSM/, '');
  }


  /********************************** BOOLEAN_COLUMN *******************************/

  public getValue(): string {
    if (this.columnValue[this.columnData.columnName]) {
      return this.columnValue[this.columnData.columnName].toString() === "true" ? "Yes" : "No";
    } else {
      return "No";
    }
  }

}
